import { createVNode as _createVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, toHandlers as _toHandlers, mergeProps as _mergeProps, withCtx as _withCtx, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "modal-wrap default-modal" }
const _hoisted_2 = {
  class: "modal fade",
  "data-backdrop": "static",
  "data-keyboard": "false",
  id: "projectAcknowledgement",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_3 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-header" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "d-block" }, [
  /*#__PURE__*/_createVNode("h5", {
    class: "modal-title",
    id: "exampleModalLabel"
  }, " Project Acknowledgement ")
], -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_8 = { class: "modal-body" }
const _hoisted_9 = { action: "#" }
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = /*#__PURE__*/_createVNode("label", { for: "" }, "Payer Emails", -1)
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-md-6" }
const _hoisted_14 = { class: "col-md-6" }
const _hoisted_15 = /*#__PURE__*/_createVNode("i", { class: "fa fa-plus-circle mr-2" }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Add Email ")
const _hoisted_17 = { class: "col-md-12" }
const _hoisted_18 = { class: "mb-0" }
const _hoisted_19 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times-circle" }, null, -1)
const _hoisted_20 = { class: "row" }
const _hoisted_21 = { class: "col-md-6" }
const _hoisted_22 = { class: "form-group" }
const _hoisted_23 = /*#__PURE__*/_createVNode("label", { for: "" }, "Name", -1)
const _hoisted_24 = { class: "col-md-6" }
const _hoisted_25 = { class: "form-group" }
const _hoisted_26 = /*#__PURE__*/_createVNode("label", { for: "" }, "Estimation", -1)
const _hoisted_27 = { class: "form-group" }
const _hoisted_28 = /*#__PURE__*/_createVNode("label", { for: "" }, "Details", -1)
const _hoisted_29 = { class: "row" }
const _hoisted_30 = { class: "col-md-6" }
const _hoisted_31 = { class: "form-group" }
const _hoisted_32 = /*#__PURE__*/_createVNode("label", { for: "" }, "Start Date", -1)
const _hoisted_33 = { class: "col-md-6" }
const _hoisted_34 = { class: "form-group" }
const _hoisted_35 = /*#__PURE__*/_createVNode("label", { for: "" }, "End Date", -1)
const _hoisted_36 = { class: "form-group" }
const _hoisted_37 = /*#__PURE__*/_createVNode("label", { for: "" }, "Attachements (Docs)", -1)
const _hoisted_38 = {
  key: 0,
  class: "image-in-chat preview-image-list"
}
const _hoisted_39 = { class: "row mx-n2" }
const _hoisted_40 = {
  key: 0,
  class: "shadowed-card bg-white mb-2"
}
const _hoisted_41 = {
  key: 0,
  class: "loader-wrapper"
}
const _hoisted_42 = /*#__PURE__*/_createVNode("span", {
  class: "spinner-border",
  role: "status"
}, [
  /*#__PURE__*/_createVNode("span", { class: "sr-only" }, "Loading...")
], -1)
const _hoisted_43 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_44 = { class: "imaged-col" }
const _hoisted_45 = { class: "small-img-wrap" }
const _hoisted_46 = { class: "size" }
const _hoisted_47 = {
  key: 1,
  class: "shadowed-card bg-white mb-2"
}
const _hoisted_48 = {
  key: 0,
  class: "loader-wrapper"
}
const _hoisted_49 = /*#__PURE__*/_createVNode("span", {
  class: "spinner-border",
  role: "status"
}, [
  /*#__PURE__*/_createVNode("span", { class: "sr-only" }, "Loading...")
], -1)
const _hoisted_50 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_51 = { class: "imaged-col" }
const _hoisted_52 = { class: "small-img-wrap" }
const _hoisted_53 = { class: "size" }
const _hoisted_54 = {
  key: 2,
  class: "shadowed-card bg-white mb-2"
}
const _hoisted_55 = {
  key: 0,
  class: "loader-wrapper"
}
const _hoisted_56 = /*#__PURE__*/_createVNode("span", {
  class: "spinner-border",
  role: "status"
}, [
  /*#__PURE__*/_createVNode("span", { class: "sr-only" }, "Loading...")
], -1)
const _hoisted_57 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_58 = { class: "imaged-col" }
const _hoisted_59 = /*#__PURE__*/_createVNode("div", { class: "small-img-wrap" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-file-word" })
], -1)
const _hoisted_60 = { class: "size" }
const _hoisted_61 = {
  key: 3,
  class: "media-wrap shadowed-card bg-white mb-2"
}
const _hoisted_62 = {
  key: 0,
  class: "loader-wrapper"
}
const _hoisted_63 = /*#__PURE__*/_createVNode("div", { class: "centered-wrap" }, [
  /*#__PURE__*/_createVNode("span", {
    class: "spinner-border big-spinner",
    role: "status"
  }, [
    /*#__PURE__*/_createVNode("span", { class: "sr-only" }, "Loading...")
  ])
], -1)
const _hoisted_64 = { class: "size" }
const _hoisted_65 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_66 = /*#__PURE__*/_createVNode("div", { class: "text-center" }, [
  /*#__PURE__*/_createVNode("p", null, "OR")
], -1)
const _hoisted_67 = { class: "form-group" }
const _hoisted_68 = /*#__PURE__*/_createVNode("label", { for: "" }, "Edoc Link", -1)
const _hoisted_69 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ErrorList = _resolveComponent("ErrorList")
  const _component_DebouncedCurrencyInput = _resolveComponent("DebouncedCurrencyInput")
  const _component_v_date_picker = _resolveComponent("v-date-picker")
  const _component_DragAndDropZone = _resolveComponent("DragAndDropZone")
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode("button", {
              type: "button",
              class: "close",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.hideProjectAcknowledgementModal && _ctx.hideProjectAcknowledgementModal(...args))),
              "aria-label": "Close"
            }, [
              _hoisted_7
            ])
          ]),
          _createVNode("div", _hoisted_8, [
            _createVNode(_component_ErrorList, {
              errors: _ctx.state.ui.errors.errorList.approval,
              hasError: _ctx.state.ui.errors.hasError
            }, null, 8, ["errors", "hasError"]),
            _createVNode("form", _hoisted_9, [
              _createVNode("div", _hoisted_10, [
                _hoisted_11,
                _createVNode("div", _hoisted_12, [
                  _createVNode("div", _hoisted_13, [
                    _withDirectives(_createVNode("input", {
                      type: "text",
                      class: "form-control",
                      onKeydown: _cache[2] || (_cache[2] = _withKeys(
//@ts-ignore
(...args) => (_ctx.addPayers && _ctx.addPayers(...args)), ["enter"])),
                      placeholder: "Type email and press enter or click add button",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.state.data.projectAckowledgement.payer = $event))
                    }, null, 544), [
                      [_vModelText, _ctx.state.data.projectAckowledgement.payer]
                    ])
                  ]),
                  _createVNode("div", _hoisted_14, [
                    _createVNode("button", {
                      type: "button",
                      class: "btn btn-soft-success  mt-md-0 mt-2",
                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.addPayers && _ctx.addPayers(...args)))
                    }, [
                      _hoisted_15,
                      _hoisted_16
                    ])
                  ]),
                  _createVNode("div", _hoisted_17, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data
                      .projectAckowledgement.payers, (payer, payerIndex) => {
                      return (_openBlock(), _createBlock("div", {
                        key: payerIndex,
                        class: "email-tag"
                      }, [
                        _createVNode("p", _hoisted_18, [
                          _createTextVNode(_toDisplayString(payer) + " ", 1),
                          _createVNode("a", {
                            href: "javascript:void(0)",
                            onClick: ($event: any) => (_ctx.removeSelectedUser(payer))
                          }, [
                            _hoisted_19
                          ], 8, ["onClick"])
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_20, [
                _createVNode("div", _hoisted_21, [
                  _createVNode("div", _hoisted_22, [
                    _hoisted_23,
                    _withDirectives(_createVNode("input", {
                      disabled: "",
                      type: "text",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.state.data.projectAckowledgement.name = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.state.data.projectAckowledgement.name]
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_24, [
                  _createVNode("div", _hoisted_25, [
                    _hoisted_26,
                    _createVNode(_component_DebouncedCurrencyInput, {
                      class: "form-control",
                      modelValue: _ctx.state.data.projectAckowledgement.estimatedBudget,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.state.data.projectAckowledgement.estimatedBudget = $event)),
                      options: {
                        currency: 'USD',
                        hideCurrencySymbolOnFocus: false,
                        hideGroupingSeparatorOnFocus: false,
                        hideNegligibleDecimalDigitsOnFocus: false,
                      }
                    }, null, 8, ["modelValue"])
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_27, [
                _hoisted_28,
                _withDirectives(_createVNode("textarea", {
                  class: "form-control",
                  rows: "6",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.state.data.projectAckowledgement.description = $event))
                }, null, 512), [
                  [_vModelText, _ctx.state.data.projectAckowledgement.description]
                ])
              ]),
              _createVNode("div", _hoisted_29, [
                _createVNode("div", _hoisted_30, [
                  _createVNode("div", _hoisted_31, [
                    _hoisted_32,
                    _createVNode(_component_v_date_picker, {
                      modelValue: _ctx.state.data.projectAckowledgement.startDate,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.state.data.projectAckowledgement.startDate = $event)),
                      "min-date": _ctx.state.data.todayData
                    }, {
                      default: _withCtx(({ inputValue, inputEvents }) => [
                        _createVNode("input", _mergeProps({
                          class: "form-control",
                          value: inputValue
                        }, _toHandlers(inputEvents), { placeholder: "Select Start Date" }), null, 16, ["value"])
                      ]),
                      _: 1
                    }, 8, ["modelValue", "min-date"])
                  ])
                ]),
                _createVNode("div", _hoisted_33, [
                  _createVNode("div", _hoisted_34, [
                    _hoisted_35,
                    _createVNode(_component_v_date_picker, {
                      modelValue: _ctx.state.data.projectAckowledgement.endDate,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.state.data.projectAckowledgement.endDate = $event)),
                      "min-date": _ctx.state.data.projectAckowledgement.startDate
                    }, {
                      default: _withCtx(({ inputValue, inputEvents }) => [
                        _createVNode("input", _mergeProps({
                          class: "form-control",
                          value: inputValue
                        }, _toHandlers(inputEvents), {
                          placeholder: "Select End Date",
                          disabled: _ctx.state.ui.isLoading.enableEndDate
                        }), null, 16, ["value", "disabled"])
                      ]),
                      _: 1
                    }, 8, ["modelValue", "min-date"])
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_36, [
                _hoisted_37,
                _createVNode(_component_DragAndDropZone, {
                  onDrop: _withModifiers(_ctx.dropFiles, ["prevent"]),
                  onDropFiles: _ctx.dropFiles
                }, null, 8, ["onDrop", "onDropFiles"]),
                (
                  _ctx.state.data.projectAckowledgement.attachments &&
                  _ctx.state.data.projectAckowledgement.attachments.length
                )
                  ? (_openBlock(), _createBlock("div", _hoisted_38, [
                      _createVNode("div", _hoisted_39, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data
                      .projectAckowledgement.attachments, (image, imageIndex) => {
                          return (_openBlock(), _createBlock("div", {
                            class: "col-sm-6",
                            key: imageIndex
                          }, [
                            (
                        image.extension === 'jpg' ||
                        image.extension === 'png' ||
                        image.extension === 'jpeg' ||
                        image.extension === 'gif'
                      )
                              ? (_openBlock(), _createBlock("div", _hoisted_40, [
                                  (image.isuploded)
                                    ? (_openBlock(), _createBlock("div", _hoisted_41, [
                                        _hoisted_42
                                      ]))
                                    : _createCommentVNode("", true),
                                  _createVNode("a", {
                                    class: "remove-btnn",
                                    href: "javascript:void(0)",
                                    onClick: ($event: any) => (_ctx.removeSelectedImage(image))
                                  }, [
                                    _hoisted_43
                                  ], 8, ["onClick"]),
                                  _createVNode("div", _hoisted_44, [
                                    _createVNode("div", _hoisted_45, [
                                      _createVNode("img", {
                                        src: image.file,
                                        alt: "",
                                        height: "200"
                                      }, null, 8, ["src"])
                                    ]),
                                    _createVNode("h5", null, _toDisplayString(image.name), 1),
                                    _createVNode("p", _hoisted_46, _toDisplayString(image.size), 1)
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (image.extension === 'pdf')
                              ? (_openBlock(), _createBlock("div", _hoisted_47, [
                                  (image.isuploded)
                                    ? (_openBlock(), _createBlock("div", _hoisted_48, [
                                        _hoisted_49
                                      ]))
                                    : _createCommentVNode("", true),
                                  _createVNode("a", {
                                    class: "remove-btnn",
                                    href: "javascript:void(0)",
                                    onClick: ($event: any) => (_ctx.removeSelectedImage(image))
                                  }, [
                                    _hoisted_50
                                  ], 8, ["onClick"]),
                                  _createVNode("div", _hoisted_51, [
                                    _createVNode("div", _hoisted_52, [
                                      _createVNode("img", {
                                        src: 
                              _ctx.state.data.imageBaseUrl
                                ? `${_ctx.state.data.imageBaseUrl}img/pdf.jpg`
                                : 'img/pdf.jpg'
                            ,
                                        alt: ""
                                      }, null, 8, ["src"])
                                    ]),
                                    _createVNode("h5", null, _toDisplayString(image.name), 1),
                                    _createVNode("p", _hoisted_53, _toDisplayString(image.size), 1)
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (
                        image.extension === 'doc' ||
                        image.extension === 'docx'
                      )
                              ? (_openBlock(), _createBlock("div", _hoisted_54, [
                                  (image.isuploded)
                                    ? (_openBlock(), _createBlock("div", _hoisted_55, [
                                        _hoisted_56
                                      ]))
                                    : _createCommentVNode("", true),
                                  _createVNode("a", {
                                    class: "remove-btnn",
                                    href: "javascript:void(0)",
                                    onClick: ($event: any) => (_ctx.removeSelectedImage(image))
                                  }, [
                                    _hoisted_57
                                  ], 8, ["onClick"]),
                                  _createVNode("div", _hoisted_58, [
                                    _hoisted_59,
                                    _createVNode("h5", null, _toDisplayString(image.name), 1),
                                    _createVNode("p", _hoisted_60, _toDisplayString(image.size), 1)
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (
                        image.extension === 'mp4' ||
                        image.extension === 'mov' ||
                        image.extension === 'MOV' ||
                        image.extension === 'wmv' ||
                        image.extension === 'webm' ||
                        image.extension === 'ogg' ||
                        image.extension === 'avi' ||
                        image.extension === 'x-ms-wmv'
                      )
                              ? (_openBlock(), _createBlock("div", _hoisted_61, [
                                  (image.isuploded)
                                    ? (_openBlock(), _createBlock("div", _hoisted_62, [
                                        _hoisted_63
                                      ]))
                                    : _createCommentVNode("", true),
                                  _createVNode("img", {
                                    src: 
                          _ctx.state.data.imageBaseUrl
                            ? `${_ctx.state.data.imageBaseUrl}img/video-icon.png`
                            : 'img/video-icon.png'
                        ,
                                    alt: "",
                                    height: "200"
                                  }, null, 8, ["src"]),
                                  _createVNode("h5", null, _toDisplayString(image.name), 1),
                                  _createVNode("p", _hoisted_64, _toDisplayString(image.size), 1),
                                  _createVNode("a", {
                                    class: "remove-btnn",
                                    href: "javascript:void(0)",
                                    onClick: ($event: any) => (_ctx.removeSelectedImage(image))
                                  }, [
                                    _hoisted_65
                                  ], 8, ["onClick"])
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _hoisted_66,
              _createVNode("div", _hoisted_67, [
                _hoisted_68,
                _withDirectives(_createVNode("input", {
                  type: "text",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.state.data.projectAckowledgement.edocLink = $event)),
                  placeholder: "https://qa.convorally.com"
                }, null, 512), [
                  [_vModelText, _ctx.state.data.projectAckowledgement.edocLink]
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_69, [
            _createVNode(_component_Button, {
              buttonName: _ctx.state.data.buttonName,
              buttonLoading: _ctx.state.ui.isPostLoading.acknowledgeRequest,
              onButtonTrigger: _ctx.acknowledgeRequest
            }, null, 8, ["buttonName", "buttonLoading", "onButtonTrigger"]),
            _createVNode("button", {
              type: "button",
              class: "btn secondary-btn",
              onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.hideProjectAcknowledgementModal && _ctx.hideProjectAcknowledgementModal(...args)))
            }, " Cancel ")
          ])
        ])
      ])
    ])
  ]))
}